function getTagIdFromTagName(tag_name) {
  return 'tag_id_' + tag_name.replace(/[\[|\]|(|)| |&]|\\|\//g, '-');
}

export { getTagIdFromTagName };
